<template>
  <van-popup v-model="isShow" :overlay-style="{ background: 'transparent' }" position="left" class="menu-group-list-popup">
    <ul class="menu-group-list">
      <template v-for="(item, index) in menuList">
        <li v-if="!item.hidden" class="menu-group-item" :key="index"
        >
          <div class="group-item-title-container">
            <i class="group-item-icon iconfont" :class="item.iconClass"></i>
            <div class="group-item-title">
              <label>{{ item.label || $t(item.labelI18nKey) }}</label>
            </div>
          </div>
          <ul class="menu-list">
            <template v-for="(child, childIndex) in item.children">
              <li
                v-if="!child.hidden"
                class="menu-item"
                :key="childIndex"
                :class="child.isActive && 'is-active'"
                @click.stop="onMenuItemClick(child, item)"
              >
                <div class="menu-item-bar"></div>
                <div class="menu-item-title">
                  <label>{{ child.label || $t(child.labelI18nKey) }}</label>
                </div>
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
  </van-popup>
</template>

<script>
import _ from 'lodash'
import * as referralsRoute from '../../views/personal/referralsRoute'
import homeRoute from '../../views/personal/homeRoute'
import referralProgramRoute from '@/views/personalNew/home/referralProgram'
import { mixedRouterPush } from '@/router/routes'
import { mapGetters } from 'vuex'
import { msdPcJobListRouteMap } from '@/views/company/msdCustomUrl/pc/route'
import { msdMobileJobListRouteMap } from '@/views/company/msdCustomUrl/mobile/route'
import { deviceType } from '@/utils/common'
import { ROOT_COMPANY_ID } from '@/constant/company'
import mixin from '@/views/personalNew/home/mixin'

export default {
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    company: {
      default: null
    },
    hideReferralProgram: {
      type: Boolean,
      default: false
    },
    hideCompanyMenu: {
      type: Boolean,
      default: false
    },
    hasLogin: {
      type: Boolean,
      default: false
    },
    isEmployeeAccount: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixin],
  data () {
    return {
      i18nKeyPrefix: 'personal.menu',
      activeMenuName: null
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    companyHasReferralPremium () {
      return this.company?.id ? this.company.premium.referral : true
    },
    companyHiddenRewards () {
      return this.company?.id ? this.company.premium.hidden_rewards : false
    },
    companyHiddenReferralRewards () {
      const account = this.getCurrentAccount
      const companyId = this.company?.root_company.id || account.employee?.company.root_company.id
      return companyId === 12600 || companyId === 12699 || companyId === 13509
    },
    companyHiddenReferralLeaderBoard () {
      const account = this.getCurrentAccount
      const companyId = this.company?.root_company.id || account.employee?.company.root_company.id
      return companyId === 13509
    },
    companyMenu () {
      if (!this.company || !this.company.id) {
        return
      }
      const company = this.company
      const rootCompany = company.root_company
      const isRootCompany = company.id === rootCompany.id
      const isMsdCustomCompany = rootCompany.id === ROOT_COMPANY_ID.MSD
      const vm = this
      return {
        hidden: this.hideCompanyMenu,
        name: 'company',
        labelI18nKey: `${this.i18nKeyPrefix}.mobile.careerSite`,
        iconClass: 'icona-CareerSite',
        onclick: (info) => {
          this.$router.push({ path: info.path, query: this.$route.query })
        },
        children: [
          {
            hidden: isRootCompany,
            name: 'rootCompanyLandingPage',
            get label () {
              return vm.isEn ? rootCompany.name : rootCompany.cn_name
            },
            path: isMsdCustomCompany ? '/msdchina/about' : `/recruiting/company/${rootCompany.id}/branding`
          },
          {
            hidden: !isRootCompany && rootCompany.id === 9936,
            name: 'companyLandingPage',
            get isActive () { return vm.$route.path.startsWith('/recruiting/company/') },
            get label () {
              return vm.isEn ? company.name : company.cn_name
            },
            path: isMsdCustomCompany ? '/msdchina/about' : `/recruiting/company/${company.id}/branding`
          }
        ]
      }
    },
    jobListMenu () {
      if (!this.company || !this.company.id) {
        return
      }
      const company = this.company
      const rootCompany = company.root_company
      const isRootCompany = company.id === rootCompany.id
      const path = '/mobile-web-more-jobs/'
      const isMsdCustomCompany = rootCompany.id === ROOT_COMPANY_ID.MSD
      let jobListRoute = null
      if (isMsdCustomCompany) {
        const msdJobListRouteMap = deviceType.isMobile ? msdMobileJobListRouteMap : msdPcJobListRouteMap
        jobListRoute = _.get(msdJobListRouteMap, company.id)
      }
      const vm = this
      return {
        hidden: false,
        name: 'jobList',
        labelI18nKey: `${this.i18nKeyPrefix}.mobile.jobsList`,
        iconClass: 'icona-JobsList',
        onclick: (info) => {
          return vm.$router.push({ path: info.path, query: this.$route.query })
        },
        children: [
          {
            hidden: isRootCompany,
            name: 'rootCompanyJobList',
            labelI18nKey: `${this.i18nKeyPrefix}.mobile.allJobs`,
            path: isMsdCustomCompany && jobListRoute ? jobListRoute.path : `${path}${rootCompany.id}/`
          },
          {
            hidden: !isRootCompany && rootCompany.id === 9936,
            name: 'companyJobList',
            get isActive () { return vm.$route.path.startsWith(path) },
            get label () {
              return vm.$t(`${vm.i18nKeyPrefix}.mobile.companyJobsList`, { company: vm.isEn ? company.name : company.cn_name })
            },
            path: isMsdCustomCompany && jobListRoute ? jobListRoute.path : `${path}${company.id}/`
          }
        ]
      }
    },
    referralsMenu () {
      if (!this.hasLogin) {
        return
      }
      const companyId = this.company?.id
      const vm = this
      const referralsRoutes = [referralsRoute.leadsRoute, referralsRoute.dashboardRoute, referralsRoute.rewardsRoute, referralsRoute.leaderBoardRoute]
      const i18nKey = ['leads', 'dashboard', 'rewards', 'leaderBoard']
      return {
        hidden: false,
        name: 'referrals',
        labelI18nKey: `${this.i18nKeyPrefix}.mobile.myReferrals`,
        iconClass: 'iconReferrals',
        onclick: (info) => {
          const query = {
            ...this.$route.query,
            company_id: companyId
          }
          vm.$router.push({ path: info.path, query: query })
        },
        children: _.map(referralsRoutes, (item, index) => {
          const child = {
            hidden: false,
            name: item.name,
            labelI18nKey: `${this.i18nKeyPrefix}.mobile.${i18nKey[index]}`,
            get isActive () {
              const currentPath = vm.$route.path
              if (currentPath === item.path) {
                return true
              }
              if (item.children) {
                const child = _.find(item.children, { path: currentPath })
                if (child) {
                  return true
                }
              }
              return false
            },
            path: item.path
          }
          if (item === referralsRoute.leaderBoardRoute) {
            child.hidden = !this.isEmployeeAccount || this.companyHiddenReferralLeaderBoard
          }
          if (item === referralsRoute.rewardsRoute) {
            child.hidden = !this.companyHasReferralPremium || this.companyHiddenRewards || this.companyHiddenReferralRewards
          }
          return child
        })
      }
    },
    accountMenu () {
      if (!this.hasLogin) {
        return
      }
      const vm = this
      const companyId = this.company?.id
      return {
        hidden: false,
        name: 'account',
        labelI18nKey: `${this.i18nKeyPrefix}.mobile.accountManagement`,
        iconClass: 'icona-AccountManagement',
        children: [
          {
            name: homeRoute.name,
            path: homeRoute.path,
            labelI18nKey: `${this.i18nKeyPrefix}.personalInformation`,
            get isActive () {
              return vm.$route.path === homeRoute.path
            },
            onclick: () => {
              const query = {
                ...this.$route.query,
                company_id: companyId
              }
              vm.$router.push({ path: homeRoute.path, query: query })
            }
          }
        ]
      }
    },
    customMenuList () {
      const query = {}
      _.forEach(this.$route.query, (value, key) => {
        if (value !== null && value !== undefined) {
          query[key] = value
        }
      })
      const queryParams = new URLSearchParams(query).toString()
      return _.chain(this.mobileCustomMenuList)
        .filter(menuGroup => menuGroup.isActive && (!menuGroup.onlyEmployee || this.isEmployeeAccount) && menuGroup.children.length > 0)
        .map(menuGroup => {
          if (menuGroup.key === 'referrals') {
            return this.generateReferralsMenu(menuGroup)
          }
          const childrenMenu = []
          const activeMenu = _.filter(menuGroup.children, child => child.isActive && (!child.onlyEmployee || this.isEmployeeAccount))
          _.forEach(activeMenu, (child) => {
            let path = child.link
            if (queryParams) {
              path = `${path}?${queryParams}`
            }
            childrenMenu.push({
              label: child.label,
              path: path,
              onclick: () => {
                window.location.href = path
              }
            })
          })
          return {
            hidden: false,
            name: menuGroup.name,
            label: menuGroup.name,
            iconClass: 'icona-AccountManagement',
            children: childrenMenu

          }
        }).filter(menuGroup => menuGroup.children.length > 0).value()
    },
    menuList () {
      const menuList = []
      if (this.company && this.company.id) {
        menuList.push(this.companyMenu, this.jobListMenu)
      }

      if (!_.isEmpty(this.customMenuList)) {
        menuList.push(...this.customMenuList)
      }
      if (this.hasLogin) {
        if (!this.hasCustomTheme) {
          menuList.push(this.referralsMenu)
        }
        menuList.push(this.accountMenu)
      }
      return menuList
    }
  },
  created () {

  },
  methods: {
    onMenuItemClick (menuItem, menuGroup) {
      if (menuItem.isActive) {
        return
      }
      this.$emit('change', false)
      if (menuItem.hasOwnProperty('onclick')) {
        menuItem.onclick()
      } else if (menuGroup.hasOwnProperty('onclick')) {
        menuGroup.onclick(menuItem)
      } else {
        mixedRouterPush(menuItem.path)
      }
    },
    generateReferralsMenu (menuGroup) {
      const companyId = this.company?.id
      const vm = this
      const referralsRoutes = [
        referralsRoute.leadsRoute,
        referralsRoute.dashboardRoute,
        referralsRoute.rewardsRoute,
        referralsRoute.leaderBoardRoute,
        referralProgramRoute
      ]
      const i18nKeyMap = {
        [referralsRoute.leadsRoute.path]: 'leads',
        [referralsRoute.dashboardRoute.path]: 'dashboard',
        [referralsRoute.rewardsRoute.path]: 'rewards',
        [referralsRoute.leaderBoardRoute.path]: 'leaderBoard',
        [referralProgramRoute.path]: 'referralProgram'
      }
      const query = {}
      _.forEach(this.$route.query, (value, key) => {
        if (value !== null && value !== undefined) {
          query[key] = value
        }
      })
      const queryParams = new URLSearchParams(query).toString()
      const childrenMenu = []
      const activeMenu = _.filter(menuGroup.children, child => child.isActive && (!child.onlyEmployee || this.isEmployeeAccount))
      _.forEach(activeMenu, (child) => {
        if (child.isDefault) {
          const route = _.find(referralsRoutes, { path: child.link })
          if (!route) {
            return
          }
          childrenMenu.push(route)
        } else {
          let path = child.link
          if (queryParams) {
            path = `${path}?${queryParams}`
          }
          childrenMenu.push({
            label: child.label,
            path: path,
            onclick: () => {
              window.location.href = path
            }
          })
        }
      })
      return {
        hidden: false,
        name: 'referrals',
        labelI18nKey: `${this.i18nKeyPrefix}.mobile.myReferrals`,
        iconClass: 'iconReferrals',
        onclick: (info) => {
          const query = {
            ...this.$route.query,
            company_id: companyId
          }
          vm.$router.push({ path: info.path, query: query })
        },
        children: _.map(childrenMenu, (item, index) => {
          const child = {
            hidden: !this.hasLogin,
            name: item.name,
            label: item.label,
            labelI18nKey: `${this.i18nKeyPrefix}.mobile.${i18nKeyMap[item.path]}`,
            get isActive () {
              const currentPath = vm.$route.path
              if (currentPath === item.path) {
                return true
              }
              if (item.children) {
                const child = _.find(item.children, { path: currentPath })
                if (child) {
                  return true
                }
              }
              return false
            },
            path: item.path
          }
          if (item === referralsRoute.leaderBoardRoute) {
            child.hidden = !this.isEmployeeAccount
          }
          if (item === referralsRoute.rewardsRoute) {
            child.hidden = !this.companyHasReferralPremium || this.companyHiddenRewards || this.companyHiddenReferralRewards
          }
          if (item.hasOwnProperty('onclick')) {
            child.onclick = item.onclick
          }
          return child
        })
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.menu-group-list-popup.van-popup {
  height: 100%;
  min-width: 70%;
  max-width: 80%;
  padding-top: 50px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .9);
  color: #dfdfdf;
  font-size: 14px;

  .menu-group-list {
    .menu-group-item {
      margin-bottom: 30px;
      border-bottom: 1px solid #888;

      &:last-child {
        border-bottom: 0;
      }

      .group-item-title-container {
        margin-left: 10px;

        .group-item-icon {
          display: inline-block;
          font-size: 26px;
          vertical-align: middle;
        }

        .group-item-title {
          display: inline-block;
          margin-left: 5px;
          font-size: 18px;
          color: #888;
          vertical-align: middle;
        }
      }

      .menu-list {
        padding: 15px 0;

        .menu-item {
          display: flex;
          margin: 10px 0;
          cursor: pointer;

          &.is-active, &:hover {
            .menu-item-bar {
              background: var(--custom-color, #ee7800);
            }

            .menu-item-title {
              background: rgba(255, 255, 255, 0.4);
            }
          }

          &:first-child {
            margin-top: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }

          .menu-item-bar {
            width: 5px;
            cursor: pointer;
          }

          .menu-item-title {
            flex: 1;
            padding: 10px 5px 10px 50px;
            overflow: hidden;
            white-space: nowrap;
            word-break: keep-all;
            text-overflow: ellipsis;

            label {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
